import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5628%3A756
 *
 * @param {SvgIconProps} props - svg props
 */
export const PauseCircleIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1Z' fill={color}/>
            <path d='M9 16H10.5C10.7761 16 11 15.7761 11 15.5V8.5C11 8.22386 10.7761 8 10.5 8H9C8.72386 8 8.5 8.22386 8.5 8.5V15.5C8.5 15.7761 8.72386 16 9 16Z' fill='white'/>
            <path d='M13.5 16H15C15.2761 16 15.5 15.7761 15.5 15.5V8.5C15.5 8.22386 15.2761 8 15 8H13.5C13.2239 8 13 8.22386 13 8.5V15.5C13 15.7761 13.2239 16 13.5 16Z' fill='white'/>
        </SvgIcon>
    )
}

export default PauseCircleIcon
